import { Group, Paper, Stack, Text } from '@mantine/core';
import { fmtQty } from '../lib/format.ts';

export interface BufferStorageCell { address: string; quantity: number; cell_type: string; active: boolean }

function pathLabel(address: string): string {
  const parts = /^С-(.+)-П-(.+)-Я-(.+)$/.exec(address);
  if (!parts) return address;
  const clean = (v: string) => v.replace(/^0+(?=\d)/, '');
  return `Сектор ${parts[1]} → Полка ${clean(parts[2])} → Ячейка ${clean(parts[3])}`;
}

export function BufferStoragePath({ assigned, cells, unit }: {
  assigned?: string | null; cells?: BufferStorageCell[]; unit: string;
}) {
  const actual = cells ?? [];
  const placed = actual.filter(c => c.cell_type === 'storage' && c.address !== 'NOCELL');
  const unplaced = actual.filter(c => c.cell_type !== 'storage' || c.address === 'NOCELL');
  const showAssigned = assigned && !placed.some(c => c.address === assigned);
  return <Stack gap={6}>
    {placed.map(c => <Paper key={c.address} p="sm" radius="md" withBorder
      style={{ background: 'var(--mantine-color-blue-light)', borderColor: 'var(--mantine-color-blue-5)', borderLeftWidth: 5 }}>
      <Text size="xs" fw={700} c="blue.9">ГДЕ ЛЕЖИТ ТОВАР{!c.active ? ' · ячейка неактивна' : ''}</Text>
      <Text fw={800} fz={19} c="blue.9" style={{ overflowWrap: 'anywhere', lineHeight: 1.35 }}>{pathLabel(c.address)}</Text>
      <Group gap="xs" mt={4}><Text size="xs" fw={600}>{c.address}</Text><Text size="sm" fw={700}>{fmtQty(c.quantity, unit)}</Text></Group>
    </Paper>)}
    {showAssigned && <Paper withBorder radius="md" p="sm" style={{ background: 'var(--mantine-color-blue-light)', borderLeft: '5px solid var(--mantine-color-blue-5)' }}>
      <Text size="xs" fw={700} c="blue.9">НАЗНАЧЕННАЯ ЯЧЕЙКА · остаток в ней не учтён</Text>
      <Text fw={800} fz={19} c="blue.9" style={{ overflowWrap: 'anywhere', lineHeight: 1.35 }}>{pathLabel(assigned)}</Text>
      <Text size="xs" fw={600} mt={4}>{assigned}</Text>
    </Paper>}
    {unplaced.map(c => <Paper key={c.address} withBorder radius="md" p="xs" bg="orange.0">
      <Text size="sm" fw={700} c="orange.9">{c.address === 'NOCELL' ? 'Без размещения в ячейке' : c.cell_type === 'shipping' ? 'Зона отгрузки (SHIP)' : c.address}: {fmtQty(c.quantity, unit)}</Text>
    </Paper>)}
    {!placed.length && !assigned && !unplaced.length && <Text fw={700} c="orange.9">Ячейка хранения не указана</Text>}
  </Stack>;
}
